<template>
	<div>
		<md-content>
			<div class="md-layout md-gutter">
		       <div class="md-layout-item md-xsmall-size-100">
			      	<md-field>
				      <label>请输入APPID/ID/产品名称</label>
				      <md-input v-model="pdata.kw"></md-input>
				    </md-field>
		       </div>
		    </div> 
		    <md-content>
			    <md-table  v-if="plist.length>0">
			      <md-table-row>
			        
			        <md-table-head>发行游戏名称</md-table-head>
			        <md-table-head>更多</md-table-head>

			      </md-table-row>
			
			      <md-table-row v-for="item,index in plist">
			        <md-table-cell @click.native="goDetail(item.name)">{{item.name}}</md-table-cell>
			        <md-table-cell @click.native="goDetail(item.name)"><div style="width: 50px;">详请</div></md-table-cell>
			      </md-table-row>
				</md-table>
			    
			    <md-table  v-else>
			      <md-table-row>
			        <md-table-head>暂无信息</md-table-head>
			      </md-table-row>
				</md-table>
			 </md-content>

		    
		    
		</md-content>
	</div>
</template>

<script>
	import { getPlist,sconfig,splist, saddp, spstatus, splog, seditp, scopy } from "../api/api";
	export default {
		 data() {
		 	return{
		 		pdata: {
			        page: 1,
			        perpage: 1000,
			        theme: "",
			        status: "",
			        kw: "",
			        sort_field: "",
			        sort_by: "",
			        placement:""
			      },
			      maxPage:1,
			      plist: [],
			      pText:"请选择产品投放位置",
			      option: [] //投放位置配置
			 	}
		 	  
		 },
		   watch: {
		    "pdata.placement": {
		      handler(n, o) {
		        this.pdata.placement=n;
		        this.pdata.page=1;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    },
		    "pdata.kw": {
		      handler(n, o) {
		        this.pdata.kw=n;
		        this.pdata.page=1;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    },
		    "pdata.page": {
		      handler(n, o) {
		        this.pdata.page=n;
		        this.getList();
		      },
		      deep: true
		      // immediate: true
		    }
		  },
		 methods:{
		 	goDetail(id){
		 		this.$router.push({ path: '/product/detail/'+id })
		 	},
		    clearPlacement(s){
		    	this.pdata.placement = '';
		    },
		    getList() {
		      var p = "";
		      for (var k in this.pdata) {
		        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
		      }
		      p = p.slice(0, -1);
		      getPlist(p, this.$cookie.getCookie("login")).then(res => {
		        if (res.code == 200) {
		          this.plist = res.data.list;
		          this.maxPage = res.data.max_page;
		        }
		      });
		    },
		    goPrev(){
		    	
		    	if(this.pdata.page>1){
		    		this.pdata.page--;
		    	}
		    	
		    },
		    goNext(){
		    	if(this.pdata.page<this.maxPage){
		    		this.pdata.page++;
		    	}
		    	
		    }
		 },
		 mounted() {
			this.getList();

		 }
		 
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// Plist.vue?b4af1adc